import styled from 'styled-components'

const StyledButton = styled.button`

    margin-left: 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 900;
    padding: 5px 8px;
    background-color: #000000;
    color: FloralWhite;
    max-width: 90px;
    max-height: 35px;
    

`
export default StyledButton